import Label from '../../components/Label';
import React, { ReactNode, useState } from 'react';
import { ReadWritePermissions } from '../../../Auth/components/PermissionGate';
import { IntlShape, useIntl } from 'react-intl';
import { ValidationResult } from '../../../util/validation/interfaces';
import { getHelp } from '../../../util/intl.utils';
import { AutoComplete, AutoCompleteChangeEvent } from 'primereact/autocomplete';

interface TitledAutoCompleteProps {
  id: string;
  value: any;
  permissions?: ReadWritePermissions;
  validation?: ValidationResult;
  onChange: (value: any) => void;
  label: string;
  labelProps?: any;
  suggestions: string[];
  disabled?: boolean;
  autoFocus?: boolean;
  className?: string;
  appendTo?: 'self' | HTMLElement | undefined | null | (() => HTMLElement);
  length?: number;
  required?: boolean;
}

export const TitledAutoComplete = (props: TitledAutoCompleteProps): ReactNode => {
  const intl: IntlShape = useIntl();
  const [items, setItems] = useState<string[]>([]);

  const search = (): void => {
    setItems(props.suggestions);
  };

  return (
    <div className={'flex flex-column gap-2'}>
      <h4 className={'m-0 w-12'}>
        <Label
          label={props.labelProps ? intl.formatMessage({id: `${props.label}.label`}, props.labelProps) : intl.formatMessage({id: `${props.label}.label`})}
          validation={props.validation}
          required={props.permissions?.required || props.required}
          htmlFor={props.id}
          help={getHelp(intl, `${props.label}.help`)}
        />
      </h4>
      <AutoComplete
        id={props.id}
        appendTo={props.appendTo}
        value={props.value}
        required={props.permissions?.required || props.required}
        invalid={props.validation && !props.validation?.valid}
        disabled={(props.permissions && !props.permissions.canWrite) || props.disabled}
        suggestions={items}
        onChange={(e: AutoCompleteChangeEvent): void => props.onChange(e.target.value)}
        completeMethod={search}
        autoFocus={props.autoFocus}
        className={props.className}
        placeholder={intl.formatMessage({id: `${props.label}.label`})}
        dropdown={true}
      />
    </div>
  );
};
